import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import type { Plan } from "@/hooks/useSubscription";

interface UpgradeOverlayProps {
  requiredPlan: "starter" | "growth";
  children: React.ReactNode;
  currentPlan: Plan;
  /** Number of items to show before blurring (for list-based content) */
  previewCount?: number;
}

export default function UpgradeOverlay({ requiredPlan, children, currentPlan }: UpgradeOverlayProps) {
  const navigate = useNavigate();
  const planLabel = requiredPlan === "starter" ? "Starter" : "Growth";

  const shouldGate =
    (requiredPlan === "starter" && currentPlan === "free") ||
    (requiredPlan === "growth" && currentPlan !== "growth");

  if (!shouldGate) return <>{children}</>;

  return (
    <div className="relative">
      <div className="pointer-events-none select-none" style={{ filter: "blur(6px)" }}>
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center bg-background/60 backdrop-blur-sm rounded-lg">
        <div className="text-center space-y-3 max-w-xs">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
            <Lock className="w-5 h-5 text-primary" />
          </div>
          <h3 className="text-sm font-semibold text-foreground">
            Upgrade to {planLabel}
          </h3>
          <p className="text-xs text-muted-foreground">
            Unlock this section with the {planLabel} plan{requiredPlan === "starter" ? " — $19/mo" : " — $39/mo"}.
          </p>
          <Button size="sm" onClick={() => navigate("/pricing")} className="glow-primary">
            View Plans
          </Button>
        </div>
      </div>
    </div>
  );
}
